function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "undraw_create_svg__a",
  x1: 0.5,
  y1: 1,
  x2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.251
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.122
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.102
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "undraw_create_svg__b",
  x1: 0.5,
  y1: 1,
  x2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b3b3b3",
  stopOpacity: 0.251
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#b3b3b3",
  stopOpacity: 0.102
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b3b3b3",
  stopOpacity: 0.051
})));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3117",
  stroke: "#e0e0e0",
  d: "M289.456 151.421s11.712-43.502-11.712-88.259",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 10,
  strokeDasharray: "0 23"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 39",
  fill: "none",
  stroke: "#e0e0e0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 10,
  d: "M125.733 146.61h0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3118",
  stroke: "#e0e0e0",
  d: "M128.875 137.257c4.133-16.882 5.367-52.077-49.216-67.018",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 10,
  strokeDasharray: "0 23.61"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 40",
  fill: "none",
  stroke: "#e0e0e0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 10,
  d: "M74.874 69.018h0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 696",
  transform: "translate(29.699 148.911)",
  fill: "url(#undraw_create_svg__a)",
  d: "M0 0h339.232v184.047H0z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 697",
  fill: "#fff",
  d: "M32.627 151.421h333.795v176.727H32.627z"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 113",
  cx: 16.313,
  cy: 16.313,
  r: 16.313,
  transform: "translate(81.148 163.133)",
  fill: "url(#undraw_create_svg__b)"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 114",
  cx: 14.64,
  cy: 14.64,
  r: 14.64,
  transform: "translate(82.821 164.806)",
  fill: "#4091f7"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 698",
  fill: "#bdbdbd",
  d: "M130.924 174.008h82.403v8.366h-82.403z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 699",
  fill: "#e0e0e0",
  d: "M97.252 228.177H303.05v8.366H97.252z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 700",
  fill: "#e0e0e0",
  d: "M97.252 209.772H303.05v8.366H97.252z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 701",
  fill: "#e0e0e0",
  d: "M97.252 246.581H303.05v8.366H97.252z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 702",
  fill: "#e0e0e0",
  d: "M97.252 264.986H303.05v8.366H97.252z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 703",
  fill: "#e0e0e0",
  d: "M97.252 283.391H303.05v8.366H97.252z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 704",
  fill: "#e0e0e0",
  d: "M97.252 301.795H303.05v8.366H97.252z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 41",
  fill: "none",
  stroke: "#bdbdbd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 10,
  d: "M64.136 148.702h0"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3119",
  stroke: "#bdbdbd",
  d: "M65.08 139.186c.318-9.043-.786-22.563-8.692-31.543",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 10,
  strokeDasharray: "0 22.87"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 42",
  fill: "none",
  stroke: "#bdbdbd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 10,
  d: "M52.914 104.363h0"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 43",
  fill: "none",
  stroke: "#e0e0e0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 10,
  d: "M253.203 152.466h0"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3120",
  stroke: "#e0e0e0",
  d: "M254.146 142.95c.318-9.043-.786-22.563-8.692-31.543",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 10,
  strokeDasharray: "0 22.87"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 44",
  fill: "none",
  stroke: "#e0e0e0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 10,
  d: "M241.98 108.128h0"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 45",
  fill: "none",
  stroke: "#bdbdbd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 10,
  d: "M333.657 148.702h0"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3121",
  stroke: "#bdbdbd",
  d: "M332.711 139.186c-.318-9.043.786-22.563 8.692-31.543",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 10,
  strokeDasharray: "0 22.87"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 46",
  fill: "none",
  stroke: "#bdbdbd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 10,
  d: "M344.879 104.363h0"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 705",
  fill: "#4091f7",
  opacity: 0.7,
  d: "M0 48.011h46.43v25.277H0z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 706",
  fill: "#4091f7",
  opacity: 0.7,
  d: "M254.32 30.861h46.43v25.277h-46.43z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 707",
  fill: "#4091f7",
  opacity: 0.7,
  d: "M214.582 76.037h46.43v25.277h-46.43z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 708",
  fill: "#4091f7",
  d: "M34.718 53.365h75.618v41.164H34.718z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 709",
  fill: "#4091f7",
  d: "M313.39 55.457h75.618v41.164H313.39z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 710",
  fill: "#4091f7",
  d: "M142.097 0h75.618v41.164h-75.618z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 47",
  fill: "none",
  stroke: "#bdbdbd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 10,
  d: "M173.172 148.283h0"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3122",
  stroke: "#bdbdbd",
  d: "M176.861 138.96c2.564-8.935 4.233-23.211-3.9-37.947-10.039-18.2-1.012-35.931 4.12-43.653",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 10,
  strokeDasharray: "0 24.01"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 48",
  fill: "none",
  stroke: "#bdbdbd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 10,
  d: "M180.073 53.332h0"
});

function SvgUndrawCreate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 389.009,
    height: 332.957
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34);
}

export default SvgUndrawCreate;